var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c0a00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2096.42,346.92H903.58c-307.35,0-556.66,249.31-556.66,556.66V2096.42c0,307.35,249.31,556.66,556.66,556.66H2096.42c307.35,0,556.66-249.31,556.66-556.66V903.58C2653.08,596.23,2403.77,346.92,2096.42,346.92Zm357.85,1709.74c0,219.48-178.13,397.61-397.61,397.61H943.34c-219.48,0-397.61-178.13-397.61-397.61V943.34c0-219.48,178.13-397.61,397.61-397.61H2056.66c219.48,0,397.61,178.13,397.61,397.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1501.13,903.58c-329.23,0-596.42,267.2-596.42,596.42s267.19,596.42,596.42,596.42,596.42-267.2,596.42-596.42S1830.35,903.58,1501.13,903.58Zm0,994c-219.09,0-397.62-178.53-397.62-397.61s178.53-397.61,397.62-397.61,397.61,178.53,397.61,397.61S1720.21,1897.61,1501.13,1897.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2137.31,
    cy: 863.82,
    r: 119.28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.03fa30a650851786b4a7ba5c809f736f.svg";
export { ForwardRef as ReactComponent };